import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import CommonLayout from "layout/CommonLayout";
import MainLayout from "layout/MainLayout";
import AuthGuard from "utils/route-guard/AuthGuard";
import { element } from "prop-types";

// pages routing
const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(lazy(() => import("pages/maintenance/500")));
const MaintenanceUnderConstruction = Loadable(lazy(() => import("pages/maintenance/under-construction")));

//DashBoard
const AdHocReports = Loadable(lazy(() => import("pages/dashboard/adHocReports.js")));
const AnalyticCharts = Loadable(lazy(() => import("pages/dashboard/analyticsCharts.js")));
const EmployeeList = Loadable(lazy(() => import("pages/pos/employeeList.js")));
const Receipt = Loadable(lazy(() => import("pages/receipt/receipt.js")));


//Order
const OrderList = Loadable(lazy(() => import("pages/order/orderList.js")));
const OrderDetail = Loadable(lazy(() => import("pages/order/orderDetail.js")));
const CustomerOrderList = Loadable(lazy(() => import('pages/order/customerOrderList.js')));
const OrderRatings = Loadable(lazy(() => import("pages/feedback/orderRatings.js")));
const SiteFeedbacks = Loadable(lazy(() => import("pages/feedback/siteFeedbacks.js")));
const CustomerList = Loadable(lazy(() => import("pages/order/customerList.js")));

//Items
const DisabledPosItemList = Loadable(lazy(() => import("pages/menu/disabledPosItemList.js")));
const AccessDenied = Loadable(lazy(() => import("pages/maintenance/accessDenied.js")));

//PO
const POList = Loadable(lazy(() => import("pages/inventory/purchaseOrder/poList.js")));
const PhysicalStock = Loadable(lazy(() => import("pages/inventory/physicalStock/physicalStock.js")));
const StockReport = Loadable(lazy(() => import("pages/inventory/stockReport/stockReport.js")))
const AddEditPo = Loadable(lazy(() => import("pages/inventory/purchaseOrder/addEditPO.js")))
const Wastage = Loadable(lazy(() => import("pages/inventory/wastage/wastage.js")))

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "dashboard",
          children: [
            {
              path: "reports",
              element: <AdHocReports />,
            },
            {
              path: 'analytics',
              element: <AnalyticCharts />
            }
          ],
        },
        {
          path: "admin",
          children: [
            {
              path: "employees",
              element: <EmployeeList />,
            },
          ],
        },
        {
          path: "mobile-application",
          children: [
            {
              path: "disableditem",
              element: <DisabledPosItemList />,
            },
          ],
        },
        {
          path: "inventory",
          children: [
            {
              path: "polist",
              element: <POList />,
            },
            {
              path: 'addEditPo',
              element: <AddEditPo />
            },
            {
              path: "physical-stock",
              element: <PhysicalStock />,
            },
            {
              path: "wastage",
              element: <Wastage />,
            },
            {
              path: 'stock-report',
              element: <StockReport />
            },

          ],
        },
        {
          path: "order",
          children: [
            {
              path: "orders",
              element: <OrderList />,
            },
            {
              path: "feedback",
              element: <OrderRatings />,
            },
            {
              path: "sitefeedback",
              element: <SiteFeedbacks />,
            },
            {
              path: "customer",
              element: <CustomerList />
            }
          ],
        },
        {
          path: "/maintenance",
          element: <CommonLayout />,
          children: [
            {
              path: "access-denied",
              element: <AccessDenied />,
            },
            {
              path: "404",
              element: <MaintenanceError />,
            },
            {
              path: "500",
              element: <MaintenanceError500 />,
            },
            {
              path: "under-construction",
              element: <MaintenanceUnderConstruction />,
            },
          ],
        },
        {
          path: "customer/orders",
          element: <CustomerOrderList />
        },
        {
          path: "detail/:orderId",
          element: <OrderDetail />,
        },
      ],
    },
    {
      path: '/receipt/:orderId',
      element: <Receipt />
    },
    {
      path: '/receipt/:flavourId/:orderId',
      element: <Receipt />
    }
  ],
};

export default MainRoutes;
